<div class="announcements-widget mat-elevation-z2">
  <div class="widget-header"
    role="button"
    tabindex="0"
    [attr.aria-expanded]="isExpanded"
    (click)="toggleExpand()"
    (keydown.enter)="toggleExpand()"
    (keydown.space)="toggleExpand(); $event.preventDefault()">
    <div class="widget-title">
      <mat-icon [matBadge]="attentionCount$ | async" [matBadgeHidden]="(attentionCount$ | async) === 0" matBadgeColor="warn" aria-hidden="false">
        campaign
      </mat-icon>
      <span>{{ 'ANNOUNCEMENTS.WIDGET.TITLE' | translate }}</span>
    </div>
    <mat-icon class="expand-icon" aria-hidden="true">{{ isExpanded ? 'expand_less' : 'expand_more' }}</mat-icon>
  </div>

  @if (isExpanded) {
    <div class="widget-content-anim" animate.enter="expand-enter" animate.leave="expand-leave">
      <div class="widget-content">
      @if (isLoading) {
        <div class="loading-state">
          <mat-spinner diameter="32"></mat-spinner>
        </div>
      }
      @if (!isLoading && loadError) {
        <div class="empty-state error-state">
          <mat-icon class="empty-icon">error_outline</mat-icon>
          <p>{{ 'ANNOUNCEMENTS.MESSAGES.LOAD_ERROR' | translate }}</p>
          <button mat-stroked-button class="btn-secondary" (click)="loadAnnouncements()">
            <mat-icon>refresh</mat-icon>
            {{ 'RETRY' | translate }}
          </button>
        </div>
      }
      @if (!isLoading && !loadError && announcements.length === 0) {
        <div class="empty-state">
          <mat-icon class="empty-icon">inbox</mat-icon>
          <p>{{ 'ANNOUNCEMENTS.WIDGET.NO_NOTIFICATIONS' | translate }}</p>
        </div>
      }
      @if (!isLoading && !loadError && announcements.length > 0) {
        <mat-action-list class="announcements-list">
          @for (notification of announcements; track notification; let last = $last) {
            <button
              mat-list-item
              type="button"
              class="notification-item"
              [class.unread-item]="!notification.seen"
              (click)="onNotificationClick(notification)">
              <mat-icon matListItemIcon class="notification-icon" [class.unread-icon]="!notification.seen">
                {{ notification.seen ? 'drafts' : 'mail' }}
              </mat-icon>
              <div matListItemTitle class="notification-title" [class.unread-title]="!notification.seen">
                {{ notification.title }}
              </div>
              @if (notification.priority === AnnouncementPriority.High || notification.priority === AnnouncementPriority.Low || isAckPendingForCaller(notification)) {
                <div matListItemLine class="notification-badges">
                  @if (notification.priority === AnnouncementPriority.High) {
                    <span class="priority-badge high">
                      <mat-icon>priority_high</mat-icon>
                      {{ 'ANNOUNCEMENTS.PRIORITY.HIGH' | translate }}
                    </span>
                  }
                  @if (notification.priority === AnnouncementPriority.Low) {
                    <span class="priority-badge low">{{ 'ANNOUNCEMENTS.PRIORITY.LOW' | translate }}</span>
                  }
                  @if (isAckPendingForCaller(notification)) {
                    <span class="priority-badge ack">
                      <mat-icon>fact_check</mat-icon>
                      {{ 'ANNOUNCEMENTS.ACK.REQUIRED' | translate }}
                    </span>
                  }
                </div>
              }
              <div matListItemLine class="notification-preview">
                {{ getNotificationPreview(notification.body) }}
              </div>
              @if (hasEditedMarker(notification)) {
                <div matListItemLine class="edited-marker">
                  {{ 'ANNOUNCEMENTS.EDIT.EDITED_AT' | translate: { date: (notification.editedAt | date: ('ANNOUNCEMENTS.FORMAT.DATE_TIME' | translate)) } }}
                </div>
              }
              <div matListItemMeta class="notification-meta">
                <span class="time-ago">{{ getTimeAgo(displayDate(notification)) }}</span>
              </div>
              @if (!last) {
                <mat-divider></mat-divider>
              }
            </button>
          }
        </mat-action-list>
      }
      @if (!isLoading && !loadError && announcements.length > 0) {
        <div class="widget-footer">
          <button mat-button class="view-all-button" (click)="onViewAll()">
            {{ 'ANNOUNCEMENTS.WIDGET.VIEW_ALL' | translate }}
            <mat-icon>arrow_forward</mat-icon>
          </button>
        </div>
      }
      <!-- Push subscription row — hidden until pushNotificationsEnabled = true in environment -->
      @if (pushService.canSubscribe) {
        <div class="push-subscribe-row">
          @if (!(pushService.isSubscribed$ | async)) {
            <button mat-button class="push-subscribe-button"
              (click)="onSubscribeToPush()"
              [disabled]="isSubscribingToPush">
              <mat-icon>notifications_active</mat-icon>
              {{ 'ANNOUNCEMENTS.WIDGET.ENABLE_PUSH' | translate }}
            </button>
          } @else {
            <div class="push-enabled-indicator">
              <mat-icon>notifications_active</mat-icon>
              <span>{{ 'ANNOUNCEMENTS.WIDGET.PUSH_ENABLED' | translate }}</span>
            </div>
          }
        </div>
      }
      </div>
    </div>
  }
</div>

